module.exports = {
    acessos: 'Acessos',
    colecao: {
        criacao: {
            confirmar: 'Confirmar a criação da coleção?',
            erro: 'Houve um erro ao criar a coleção',
            sucesso: 'Coleção criada com sucesso',
        },
        edicao: {
            confirmar: 'Confirmar a edição da coleção?',
            erro: 'Houve um erro ao editar a coleção',
            sucesso: 'Coleção editada com sucesso',
        },
        editar: 'Editar coleção',
        exclusao: {
            confirmar: 'Tem certeza que deseja remover esta coleção?',
            erro: 'Houve um erro ao remover a coleção. Tente novamente mais tarde.',
            sucesso: 'Coleção removida com sucesso',    
        },
        imagem: {
            validacao: {
                erro: {
                    formato: 'A imagem da coleção deve ser quadrada (ex: 500x500)',
                },
            },
        },
        colecaoFiltroManual: 'Você deseja criar uma coleção com filtros ou inserir exames manualmente?',
        escolherFiltros : 'Escolher filtros',
        insercaoManual: 'Inserção manual',
        inserirExame: 'Inserir exame',
        upload: {
            selecionarArquivoZip: 'Selecionar arquivo(s) .zip',
            arrasteOuClique: 'Arraste os arquivos aqui ou clique para selecionar',
            apenasZip: 'Apenas arquivos .zip são permitidos',
            confirmar: 'Confirmar envio dos exames selecionados?',
            erroApenasZip: 'Apenas arquivos .zip são permitidos',
        },
        ambas: 'Ambas',
        tipoInsercaoDocumentos: 'Inserção de documentos',
        novaColecao: 'Nova coleção',
        suasColecoes: 'Suas coleções',
        tipoCompartilhamento: {
            link: 'Qualquer pessoa com o link pode visualizar.',
            privada: 'Apenas usuários com acesso podem abrir usando o link.',
            publica: 'Visível publicamente na internet para leitura.',
        },
        acesso: {
            acessoRestrito: 'Acesso restrito',
            qualquerPessoaLink: 'Qualquer pessoa com o link',
            ultimoAcesso: 'Último acesso',
            totalAcessos: 'Total de acessos',
            nenhumUsuarioAdicionado: 'Nenhum usuário adicionado',
            editor: 'Editor',
            visualizador: 'Visualizador',
            digiteCpfUsuario: 'Digite o CPF do usuário',
        },
        validacao: {
            descricao: {
                erroMaximo: 'A descrição deve ter no máximo 256 caracteres',
            },
            titulo: {
                erroMaximo: 'O título deve ter no máximo 20 caracteres',
                erroMinimo: 'O título deve ter no mínimo 3 caracteres',
            },
        },
        cor: 'Cor',
        colecaoFiltroManual: 'Você deseja criar uma coleção com filtros ou inserir exames manualmente?',
        escolherFiltros: 'Escolher filtros',
        insercaoManual: 'Inserção manual',
        inserirExame: 'Inserir exame',
        tipoInsercaoDocumentos: 'Inserção de documentos',
        ambas: 'Ambas',
        upload: {
            selecionarArquivoZip: 'Selecionar arquivo(s) .zip',
            arrasteOuClique: 'Arraste os arquivos aqui ou clique para selecionar',
            apenasZip: 'Apenas arquivos .zip são permitidos',
            confirmar: 'Confirmar envio dos exames selecionados?',
            erroApenasZip: 'Apenas arquivos .zip são permitidos',
            enviando: 'Enviando arquivos...',
            sucesso: 'Exames enviados com sucesso',
            erroEnviar: 'Erro ao enviar os exames',
            erroColecaoNaoSelecionada: 'Nenhuma coleção selecionada para o upload',
            erroVincular: 'Erro ao vincular o estudo DICOM à coleção',
        },
        estudosDicom: {
            titulo: 'Processamento de estudos DICOM',
            arquivo: 'Arquivo',
            dataEnvio: 'Data do envio',
            status: 'Status',
            nenhumEstudo: 'Nenhum estudo DICOM enviado',
            statusPendente: 'Pendente',
            statusProcessando: 'Processando',
            statusSucesso: 'Sucesso',
            statusErro: 'Erro',
            exclusao: {
                confirmar: 'Deseja remover este exame da coleção? O estudo DICOM será removido, mas permanecerá no PACS.',
                sucesso: 'Exame removido da coleção com sucesso',
                erro: 'Erro ao remover o exame da coleção',
            },
        },
        compartilhamento: {
            voceJaPossuiAcessoColecao: 'Você já possui acesso a esta coleção.',
            adicionarColecao: 'Adicionar coleção',
            desejaAdicionarColecao: (titulo) => `Deseja ter acesso a coleção "${titulo}"?`
        }
    },
    colecoes: 'Coleções',
    copiarLink: 'Copiar link',
    criadoPor: 'Criado por',
    documentos: 'Documentos',
};